import React, { useState, useEffect } from "react";
import swal from "sweetalert";

const CropRatio = (props) => {
  const [aspectRatios, setAspectRatios] = useState(
    props.defaultSize || "Photo News",
  );
  const [returnUploaders, setReturnUploader] = useState("");

  const aspectRatioOptions = [
    { value: "", name: "Select the Image Type" },
    { value: "Photo News", name: "Photo News" },
    { value: "Speeches", name: "Speeches" },
    { value: "Passport", name: "Passport" },
    { value: "Website Banner", name: "Website Banner" },
    { value: "Landscape", name: "Landscape Photo" },
  ];

  // receive uploaded file
  useEffect(() => {
    setReturnUploader(props.returnUploader);
  }, [props.returnUploader]);

  // auto select passed value
  useEffect(() => {
    if (props.defaultRatio !== undefined) {
      setAspectRatios(props.defaultRatio);
    }
  }, [props.defaultRatio]);

  async function cropPhotoImage(event) {
    event.preventDefault();

    if (!aspectRatios || !returnUploaders) {
      return swal(
        "Caution",
        "Please select an image and image type",
        "warning",
      );
    }

    // 🔥 ADD THIS LINE (important)
  props.setRequireCrop?.(true);

  props.setCropImage(returnUploaders);
  props.setCloseModal(true);
  }

  return (
    <>
      <div className="col-md-12 mb-3">
        <select
          className="form-select"
          value={aspectRatios}
          onChange={(e) => {
            const value = e.target.value;
            setAspectRatios(value);
            props.setReturnRatio(value); // send to parent ONCE here
          }}
        >
          {aspectRatioOptions.map((item, i) => (
            <option value={item.value} key={i}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        className="btn btn-warning col-12"
        onClick={cropPhotoImage}
      >
        <i className="fa fa-image me-1"></i>
        Crop Photo Image
      </button>
    </>
  );
};

export default CropRatio;
